import * as store from '@attain-apps/fe/web/main/lib/store'

import type { Plugin } from '../plugin'
import { State } from '../state'

/**
 * Lets go of the previous conversation's entries along with the collection's
 * cache.
 */
export const dropInfoEntriesOnContextChange = store.reducers.extra(
  (_feature: Plugin['feature'], plugin: Plugin) =>
    new store.reducers.ExtraReducer({
      on: [plugin.collection.feature.actions.changeContext],
      reduce: (state: State) => State.withoutAnyInfoEntries(state),
    }),
)
